import { render } from "./ApprovalForm.vue?vue&type=template&id=1699c1c6&scoped=true"
import script from "./ApprovalForm.vue?vue&type=script&lang=js"
export * from "./ApprovalForm.vue?vue&type=script&lang=js"

import "./ApprovalForm.vue?vue&type=style&index=0&id=1699c1c6&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-1699c1c6"

export default script